import { Stack, SxProps, Typography, useTheme } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

import bannerBg from './assets/baner-bg.png'

import { FundStatsBanner } from './fund-stats-banner'
import {
  StyledContainer,
  StyledBannerWrapper,
  StyledBannerSection,
  StyledBannerImage,
  // StyledComercialDescription,
} from './styled'

interface IProps {
  sx?: SxProps
}

export function Banner({ sx }: IProps) {
  const { t } = useTranslation('widgets')
  const theme = useTheme()

  return (
    <StyledBannerWrapper sx={sx}>
      <StyledBannerSection>
        <StyledContainer maxWidth="lg">
          <Stack maxWidth={{ xs: 327, md: 570 }} mt={{ xs: 11.5, md: 0 }}>
            <Typography variant="h1">
              <Trans
                i18nKey="main-page.banner.title"
                ns="widgets"
                components={{
                  accent: (
                    <span style={{ color: theme.palette.primary.main }} />
                  ),
                }}
              />
            </Typography>

            <Typography variant="text18Regular" mt={2.5}>
              {t('main-page.banner.subtitle')}
            </Typography>
          </Stack>
        </StyledContainer>

        <StyledBannerImage src={bannerBg} />
      </StyledBannerSection>

      {/* <StyledComercialDescription>
        <Typography variant="text14Regular">
          {t('main-page.banner.comercial-description')}
        </Typography>
      </StyledComercialDescription> */}

      <FundStatsBanner />
    </StyledBannerWrapper>
  )
}
